import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
} from "@mui/material";

import {
    TrendingUp,
    Payment,
    Replay,
    Subscriptions,
} from "@mui/icons-material";

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";
import { reportApi } from "../API/reportApi";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import Footer from "../Component/Footer";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";

function StatCard({
    title,
    value,
    icon,
}) {
    return (
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                        >
                            {title}
                        </Typography>

                        <Typography variant="h5" fontWeight="bold">
                            {value}
                        </Typography>
                    </Box>

                    {icon}
                </Box>
            </CardContent>
        </Card>
    );
}

export default function Dashboard() {
    const [loading, setLoading] = useState(true);
    const [revenue, setRevenue] = useState([]);
    const [gateways, setGateways] = useState([]);
    const [subs, setSubs] = useState([]);
    const [refunds, setRefunds] = useState([]);

    useEffect(() => {
        Promise.all([
            reportApi.revenue().catch(() => ({ data: [] })),
            reportApi.gateways().catch(() => ({ data: [] })),
            reportApi.subscriptions().catch(() => ({ data: [] })),
            reportApi.refunds().catch(() => ({ data: [] })),
        ]).then(([rev, gw, sub, ref]) => {
            setRevenue(rev.data || []);
            setGateways(gw.data || []);
            setSubs(sub.data || []);
            setRefunds(ref.data || []);
            setLoading(false);
        });
    }, []);

    const totalRevenue = revenue.reduce((s, r) => s + Number(r.revenue || 0), 0);
    const paymentCount = gateways.reduce((s, g) => s + Number(g.paymentCount || 0), 0);
    const trend = gateways.map((g) => ({ name: g.gateway, revenue: Number(g.netRevenue || 0) }));

    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Payments Dashboard", path: null }]} />
                            <div className="UI-header-content">
                                <div>
                                    <h1 className="UI-title">
                                        Payments Dashboard
                                    </h1>
                                    <p className="UI-subtitle">
                                        Detailed view of payments information and transactions
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">
                            {loading ? <Typography>Loading...</Typography> : (
                            <Grid container spacing={3}>

                                <Grid item xs={12} md={3}>
                                    <StatCard
                                        title="Total Revenue"
                                        value={`₹${totalRevenue.toLocaleString()}`}
                                        icon={<TrendingUp />}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <StatCard
                                        title="Payments"
                                        value={paymentCount.toLocaleString()}
                                        icon={<Payment />}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <StatCard
                                        title="Refunds"
                                        value={refunds.length.toLocaleString()}
                                        icon={<Replay />}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <StatCard
                                        title="Subscriptions"
                                        value={subs.length.toLocaleString()}
                                        icon={<Subscriptions />}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6" mb={2}>
                                                Net Revenue By Gateway
                                            </Typography>

                                            {trend.length === 0 ? <Typography color="text.secondary">No payment data yet.</Typography> : (
                                            <ResponsiveContainer
                                                width="100%"
                                                height={350}
                                            >
                                                <LineChart data={trend}>
                                                    <CartesianGrid strokeDasharray="3 3" />

                                                    <XAxis dataKey="name" />

                                                    <YAxis />

                                                    <Tooltip />

                                                    <Line
                                                        type="monotone"
                                                        dataKey="revenue"
                                                        strokeWidth={3}
                                                    />
                                                </LineChart>
                                            </ResponsiveContainer>
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </Grid>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
